module.exports = __webpack_public_path__ + "img/warning.48f4635e.svg";